<!--详情页面-->
<template>
  <el-dialog
    :title="pagetitle.indexOf(';')!=-1?pagetitle.split(';')[0]:pagetitle"
    :visible.sync="dialogMachiningVisible"
    center
    :close-on-click-modal="false" :append-to-body="true"
    custom-class="medium-dialog">
    <div ref="print1" style="width: 100%;margin: 0 auto;">
      <p :style="{display:showtitle1,textAlign:'center',fontSize:'18px',lineHeight:'40px'}">{{pagetitle.indexOf(';')!=-1?pagetitle.split(';')[0]:pagetitle}}</p>
      <!--<div v-if="controlData.isjiaji==1" style="color:red;margin-left: 20px;font-weight:bold;float:left ">-->
        <!--<span>加急！！</span>（{{controlData.wantarrivaltime}}）-->
      <!--</div>-->
      <div style="width: 640px;margin: 0 auto;text-align: right;"><img :src="imgpath"/></div>
      <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
             :style="{background:backimg}" class="print-table">
        <tr class="noborder" style="height: 26px">
          <td align="right" width="60">订单号：</td>
          <td width="140">{{controlData.erpserial}}</td>
          <td align="right" width="60"><span v-if="controlData.pcustomer==controlData.servedname||!isprint">门&nbsp;&nbsp;店：</span></td>
          <td><span style="font-size: larger"><b v-if="controlData.pcustomer==controlData.servedname||!isprint">{{controlData.customername}} {{controlData.customerserial}}</b></span></td>
          <td align="right" width="60"></td>
          <td width="200"></td>
        </tr>
        <tr class="noborder" style="height: 26px" v-if="controlData.pcustomer==controlData.servedname||!isprint">
          <td align="right">时&nbsp;&nbsp;间：</td>
          <td>{{controlData.htqd||controlData.adddate}}</td>
          <td align="right">地&nbsp;&nbsp;址：</td>
          <td>{{controlData.deliveryaddress}}</td>
          <td align="right">联系人：</td>
          <td>{{(controlData.linkman||"")+" " +((controlData.linkmantel&&controlData.linkmantel!='null')?controlData.linkmantel:'')}}</td>
        </tr>
        <tr class="noborder" style="height: 26px" v-if="controlData.pcustomer!=controlData.servedname">
          <td align="right">加工点：</td>
          <td>{{controlData.pcustomer}}</td>
          <td align="right">地&nbsp;&nbsp;址：</td>
          <td>{{controlData.caddress}}</td>
          <td align="right">联系人：</td>
          <td>{{(controlData.clinkman||"")+" " +(controlData.clinkmantel||"")}}</td>
        </tr>
        <tr class="noborder">
          <td align="right">运&nbsp;&nbsp;费：</td>
          <td>￥{{controlData.expressfee+" "+controlData.deliverymode}}<span  class="no-print"  style="color: blue;cursor:pointer;margin-left: 10px"
            v-if="!isprint&&controlData.status<500&&controlData.paymethod&&controlData.paymethod.indexOf('按合同结算')>-1&&controlData.isreturnorder!=-1"
            @click="showupdateExpressFee()">修改</span></td>
          <td align="right">加工项：</td>
          <td><span style="color: red;font-size: larger"><b>{{seedname}}&nbsp;&nbsp;x{{sumnumber}}</b> </span><span style="color: red;font-size: larger" v-if="(printDisplay||!isprint)"><b>、 {{summoney}}元</b></span></td>
          <td align="right"></td>
          <td></td>
        </tr>
        <tr class="noborder no-print" v-show="!isprint&&status>=350&&status<650" style="height:26px">
          <td align="right">物&nbsp;&nbsp;流：</td>
          <td>
            <el-select v-if="!isprint" v-model="controlData.logisticsco" placeholder="请选择" style="width: 125px;" size="mini">
              <el-option
                v-for="item in parameterData"
                :key="item.value"
                :label="item.name"
                :value="item.value">
              </el-option>
            </el-select>
            <span v-if="isprint">{{controlData.logisticsco}}</span>
          </td>
          <td align="right">快递号：</td>
          <td v-if="!isprint">
            <el-input  v-model="controlData.logisticsnum" auto-complete="off" required="true" size="mini" style="width: 135px;" placeholder="请填写快递单号"></el-input>
            <template v-if="controlData.logisticsnum">
              <el-button circle type="info" @click="OrderPrint" :loading="loading" icon="el-icon-printer" title="打印-快递单" size="mini"></el-button>
              <el-button circle type="warning" @click="RouteService" icon="el-icon-truck" title="查询-物流" size="mini"></el-button>
              <el-button circle type="danger" @click="removeOrderService" :loading="loading" icon="el-icon-delete" title="撤销-快递单" size="mini"></el-button>
            </template>
            <el-button v-else circle type="success" @click="createOrderService" :loading="loading" icon="el-icon-edit" title="创建-快递单" size="mini"></el-button>
          </td>
          <td v-else>{{controlData.logisticsnum}}</td>
          <td align="right" v-if="controlData.handleoverdate">发货时：</td>
          <td><span v-if="controlData.status>300">{{controlData.handleoverdate}}</span></td>
        </tr>
        <tr class="noborder" v-if="isreturnorder" style="font-weight:bold;cursor:pointer" @click="lookDetails(controlData.sycstagreementDO)">
          <td align="right">原订单：</td>
          <td>{{controlData.sycstagreementDO.erpserial?controlData.sycstagreementDO.erpserial:""}}</td>
          <td align="right">状 &nbsp;态：</td>
          <td>
            {{controlData.sycstagreementDO&&parseFloat(controlData.sycstagreementDO.status)>300?'已加工':'待加工'}}
          </td>
          <td align="right"></td>
          <td></td>
        </tr>
        <tr v-if="tableData.length>0">
          <td colspan="6" style="border:none">
            <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;" class="query-table">
              <tr>
                <td v-if="item !='总价'&&item !='单价'&&item !='销售单号'" style="text-align: center;" v-for="item in column">
                  {{item=='数量'?(item+'(片)'):item}}
                </td>
                <td v-if="(printDisplay)" style="text-align: center;">单价</td>
                <td v-if="(printDisplay)" style="text-align: center;">总价</td>
                <td style="text-align: center;">销售单号</td>
              </tr>
              <tr v-for="row in tableData">
                <td  v-if="item !='总价'&&item !='单价'&&item !='销售单号'"
                     v-for="item in column" :style="{textAlign:item=='产品名称'?'left':'center',minWidth:item=='产品名称'?'90px':''}">
                  <div v-if="item=='球镜'">{{row[item]}}{{row['型号']}}</div>
                  <div v-if="item=='柱镜'">{{row[item]}}{{row['规格']}}</div>
                  <div v-if="!(item=='球镜'||item=='柱镜')">{{row[item]}}</div>
                  <div v-if="!isprint&&item=='产品名称'&&row['关联产品']" style="padding-left: 50px">{{row['关联产品']}}</div>
                </td>
                <td style="text-align: center;" v-if="(printDisplay)">{{parseFloat(row['单价']).toFixed(2)}}</td>
                <td style="text-align: center;" v-if="(printDisplay)">{{parseFloat(row['总价']).toFixed(2)}}</td>
                <td v-if="!isprint" style="width: 160px"> <div style="cursor: pointer" @click="getOpenOrder(row['销售单号'])">{{row['销售单号']}} {{row['订单状态']}}</div></td>
                <td v-else style="width: 140px">{{row['销售单号']}}</td>
              </tr>
            </table>
          </td>
        </tr>
        <tr v-if="chufangdan">
          <td></td>
          <td colspan="5" style="border:none">
            <RLTable ref="RLTable1" :isview="true" :chufangdan="chufangdan"></RLTable>
          </td>
        </tr>
        <tr class="noborder">
          <td align="right">说&nbsp;&nbsp;明：</td>
          <td colspan="5" style="border: none;height: 30px">
            <div v-html="getLiuYan(controlData.remark)">
            </div>
          </td>
        </tr>
        <tr class="noborder">
          <td colspan="5" style="border:none">
            <div style="float: left" v-for="(item,index) in formproperty" v-if="item&&index!='处方单'">
              <span style="width:90px;display: inline-block;text-align: right">
              {{index+"："}}</span>
              <span style="width:70px;display: inline-block;text-align: left">{{item}}</span>
            </div>
          </td>
          <td class="no-print" v-if="!isprint">
            <el-checkbox-group v-model="checkedGlasses" @change="handleCheckedGlassesChange">
              <el-checkbox v-for="glasses in glassess" :label="glasses" :key="glasses">{{glasses}}</el-checkbox>
            </el-checkbox-group>
          </td>
        </tr>
        <tr class="noborder" style="height: 26px">
          <td align="right">开单人：</td><td>{{controlData.ssfzr||''}}</td>
          <td align="right">加工师：</td><td><div  style="float: left;width: 140px">{{controlData.fileuname||''}}</div>
            <div style="padding-right: 15px;float: right;width: 140px">支付方式：{{controlData.paymethod||""}}</div></td>
          <td colspan="2">
            <span v-if="(printDisplay||!isprint)" style="font-size: larger">总额：<b>{{(parseFloat(summoney)+parseFloat(controlData.expressfee)).toFixed(2)}}</b>元</span>
            <span v-else>&nbsp;</span>
          </td>
        </tr>
        <tr class="noborder" style="height: 30px">
          <td colspan="6"></td>
        </tr>
        <tr class="noborder" style="height: 26px">
          <td align="right">服务商：</td>
          <td v-if="isNoshow">{{pagetitle.indexOf(';')!=-1?pagetitle.split(';')[0]:pagetitle}}</td>
          <td v-else>{{controlData.applybydname}}</td>
          <td align="right">地&nbsp;&nbsp;址：</td>
          <td>{{controlData.address}}</td>
          <td align="right">联系人：</td>
          <td>{{(controlData.elinkman||"")+" "+(controlData.elinkmantel||"")}}</td>
        </tr>
        <tr v-if="!isprint">
          <td colspan="6">
            <BaoSunList ref="BaoSunList"></BaoSunList>
          </td>
        </tr>
      </table>
      <el-drawer v-if="supplystatuslist.length>0" :withHeader="false" :modal="false"
                 title="订单状态"
                 :visible.sync="supplydrawer" :wrapperClosable="true" :append-to-body="true"
                 :direction="'rtl'">
        <el-table :data="supplystatuslist" size="mini"  :height="tableHeight(-60)"
          stripe border style="width: 100%;">
          <el-table-column
            label="步骤" prop="FlagCode"
            align="left"
            header-align="center" >
          </el-table-column>
          <el-table-column
            label="时间" prop="FlagDateTime"
            align="left" width="140px"
            header-align="center">
          </el-table-column>
        </el-table>
      </el-drawer>
    </div>
    <div ref="print2Small" style="width: 100%;margin: 0 auto;" :style="{display:printShowSmall}">
    <CstagreementMachiningPrint ref="CstagreementMachiningPrint1"  :issimple="true"></CstagreementMachiningPrint>
    </div>
    <div slot="footer" class="dialog-footer no-print" v-if="!batchprint">
      <el-button @click="dialogMachiningVisible = false;" size="mini">取 消</el-button>
      <el-button type="primary" @click="delivergoods" class="qrbtn" v-if="isfahuo&&controlData.status==350" :loading="loading">确认出库</el-button>
      <el-button type="primary" @click="erchidelivergoods" class="qrbtn" v-if="btn=='邮寄'&&status==400" :loading="loading">确认发货</el-button>
      <el-button type="primary" @click="machiningOver" v-if="getBtnVisible()" class="qrbtn"  :loading="loading">加工完成</el-button>
      <el-button type="warning" @click="baosun" v-if="getZlJCVisible()" >质检不合格</el-button>
      <el-button type="primary" @click="print1(false)" size="mini" v-if="roletype!='order'&&status!=200">打印</el-button>
      <el-button type="primary" @click="print1(true)" size="mini" v-if="roletype!='order'&&status!=200&&printDisplay">打印（无价格）</el-button>
      <el-button type="primary" @click="printSmall(false)" size="mini" v-if="roletype!='order'&&status!=200">小票</el-button>
      <span @click="printloglook" style="position: absolute;bottom: 8px;right: 10px">{{tips()}}</span>
      <span @click="handleloglook" style="position: absolute;bottom: 25px;right: 10px">(处理日志)</span>
    </div>
    <printlogList ref="printlogList"></printlogList>
    <HandlelogList ref="HandlelogList"></HandlelogList>
    <CstagreementMachiningBaosun ref="machiningbaosun" @bindGrid="rebindBaoSun"></CstagreementMachiningBaosun>
    <Printtitle ref="Printtitle" @printtitlename="printtitlename" @cancelprint="cancelprint"></Printtitle>
    <UpdateExpressFee ref="UpdateExpressFee1" @afterUpdateExpressFee="afterUpdateExpressFee"></UpdateExpressFee>
  </el-dialog>
</template>


<script>

  import {machiningOrder, finishing, checkprinting, glassesArrival,multipleShipments,updateExpressFee,ercifahuo} from '@/api/set/csagreement';
  import {getRemark} from '@/plugin/ordercommon'
  import printlogList from './printlogList'
  import CstagreementMachiningBaosun from './CstagreementMachiningBaosun'
  import CstagreementMachiningPrint from './CstagreementMachiningPrint'
  import {sfOrderService, sfOrderConfirm,sfRouteService,sfOrderPrint,loadPrintFile} from '@/api/order/express';
  import {saveData, getListData} from '@/api/set/handlelog';
  import HandlelogList from './HandlelogList'
  import {save} from '@/api/order/printlog';
  import BaoSunList from './BaoSunList'
  import Printtitle from './Printtitle'
  import {getParameterDetail} from '@/api/set/parameter';
  import UpdateExpressFee from './UpdateExpressFee';
  import RLTable from '@/components/set/goodsprice/RLTable';
  export default {
    name: 'CstagreementMachiningEdit',
    data() {
      return {
        loading: false,
        backimg: '',
        imgpath: '',
        btn:'',
        isfahuo: false,
        uname: '',//最新一条打印人员
        adddate: '',//最新一条打印时间
        canOperate: 0,//加工单只有点击确认的时候才显示加工完成按钮
        dialogMachiningVisible: false,
        formLabelWidth: '120px',
        parameterData: [],
        groupguid: '',
        tableData: [],
        tableDatamap: [],
        supplystatuslist: [],
        supplydrawer: false,
        columnbaosun: [],
        unitguid: "",
        erpserial: '',
        column: [],
        chufangdan:'',
        controlData: {logisticsco: ""},
        showtitle1: "none",
        deliveryaddress: '',
        jxcstoreData: [],
        seedname: '',
        seedcode: "",
        formproperty: [],//  下部区域的参数
        count: 0,
        formpropertyData: [],
        isreturnorder: false,
        sycstagreementDO: [],
        sumnumber: '',
        summoney: '',
        handlelogData: [],//处理日期
        // categoryname:'' //镜框类型
        printDisplay: false,//是否显示单价和总价
        printShowSmall:"none",
        isprint: false,//控制价格显示
        glassess: ['镜架已到', '镜片已到'],
        checkedGlasses: [],
        roletype: '',//岗位类型
        status: '',//订单状态
        zjyright: false,
        showlookprice: false,//根据
        pagetitle: '',
        isNoshow: false,//是否需要更换服务商
      }
    },
    props: {
      batchprint: {
        default: false
      }
    },
    methods: {
      //报损
      baosun() {
        this.$refs.machiningbaosun.show(this.controlData, this.columnbaosun, this.tableDatamap)
      },
      bindBaoSun() {//绑定报损单
        var erpserials = '';
        for (let i = 0; i < this.tableData.length; i++) {
          if (erpserials.indexOf(this.tableData[i]["销售单号"]) < 0) {
            erpserials += (erpserials == '' ? '' : ';') + this.tableData[i]["销售单号"];
          }
        }
        this.$refs.BaoSunList.bind(erpserials);
      },
      showupdateExpressFee() {
        this.$refs.UpdateExpressFee1.show(this.controlData.expressfee);
      },
      //修改运费之后的回调方法
      afterUpdateExpressFee(expressfee) {
        updateExpressFee({
          unitguid: this.controlData.unitguid,
          expressfee: Math.abs(expressfee)
        }).then(response => {
          if (response.data.code == 0) {
            this.$message({
              type: 'success',
              duration: 1500,
              message: '操作成功!'
            });
            this.controlData.expressfee = Math.abs(expressfee)
          } else {
            this.$message.error('操作失败')
          }
        })
      },
      rebindBaoSun() {//重新绑定报损单
        this.$refs.BaoSunList.rebind();
      },
      //镜片、镜架是否已到
      handleCheckedGlassesChange(val) {
        var remark = ''
        if (val.length == 2) {
          remark = val[0] + "," + val[1]
        } else if (val.length == 1) {
          remark = val[0]
        }
        glassesArrival({
          unitguid: this.controlData.unitguid,
          erpserial: this.controlData.erpserial,
          remark: remark
        }).then(response => {
          //刷新列表
          this.$emit("bindGrid")
        })
      },
      //查看处理日志
      handleloglook() {
        this.$refs.HandlelogList.show()
        this.$refs.HandlelogList.initData(this.controlData.erpserial);
      },
      //处理日志
      handlelog(hn) {
        var handlelog = {}
        handlelog.erpserial = this.erpserial
        handlelog.isopen = 1
        handlelog.casestepname = hn
        handlelog.remark = hn
        if(hn=='加工完成'){
          handlelog.dserial = this.seedcode;
          handlelog.remark = this.seedname
          handlelog.totalnumber = this.sumnumber
        }
        saveData(handlelog).then(response => {})
      },
      printloglook() {
        this.$refs.printlogList.show()
        this.$refs.printlogList.initData(this.erpserial);
      },
      tips() {
        if (this.uname) {
          return "(打印人：" + this.uname + ",时间：" + this.adddate + ")"
        } else {
          return "(未打印过)"
        }
      },
      getOpenOrder(erpserial) {
          this.$parent.lookDetails({erpserial: erpserial})
      },
      getBtnVisible() {
        return this.controlData.status == 300 && this.canOperate == 1
      },
      getZlJCVisible() {
        return (this.controlData.status > 200)&&(this.controlData.status < 600) && this.zjyright && !this.isfahuo
      },
      getTitle(showname) {
        let result = [];
        if (showname && showname != '') {
          if (showname.indexOf(';') != -1) {
            var obj = showname.split(';')
            for (let i in obj) {
              if (obj[i] && i == 0) {
                result = obj[i]
              } else if (obj[i]) {
                result += ';' + obj[i]
              }
            }
          } else {
            result = showname
          }
        } else {
          let temp = localStorage.getItem("hpapi_userInfoModel")
          if (temp) {
            result += JSON.parse(temp).tenantname || ""
          }
        }
        if (result.indexOf(';') != -1) {
          var obj = result.split(';')
          for (let i in obj) {
            if (obj[i]) {
              if (this.controlData.voucherdetailguid) {
                obj[i] += "铺货单"
              } else {
                obj[i] += "加工单"
              }
              if (this.isshowyuandd) {
                obj[i] += "(退货单)"
              }
            }
          }
          result = obj.join(';')
        } else {
          if (this.controlData.voucherdetailguid) {
            result += "铺货单"
          } else {
            result += "加工单"
          }
          if (this.isshowyuandd) {
            result += "(退货单)"
          }
        }
        return result
      },
      printSmall() {
        this.printShowSmall = '';
        this.$nextTick(() => {
          this.$print(this.$refs.print2Small);
          this.printShowSmall = 'none';
        });
      },
      print1(hideprice) {
        this.showtitle1 = ""
        this.isprint = true
        checkprinting({erpserial: this.erpserial}).then(response => {
          var printD = response.data.obj.rows;
          if (printD.length > 0) {//表示打印过，需要做出提醒
            this.$confirm('该订单“' + printD[0].uname + '”已于' + printD[0].adddate + '打印过，是否继续?', '提示', {
              confirmButtonText: '取消',
              cancelButtonText: '继续打印',
              type: 'error'
            }).then(() => {
             this.cancelprint();
            }).catch(() => {
              if (this.pagetitle.indexOf(";") != -1) {
                if (this.userInfoModel.independentserial)
                  this.isNoshow = true
                this.$refs.Printtitle.show(this.pagetitle, false)
              } else {
                this.startprint(false,hideprice);
              }
            });
          } else {
            if (this.pagetitle.indexOf(";") != -1) {
              if (this.userInfoModel.independentserial)
                this.isNoshow = true
              this.$refs.Printtitle.show(this.pagetitle, true)
            } else {
              this.startprint(true,hideprice);
            }
          }
        });
      },
      printtitlename(pagetitle, needreflash) {
        this.pagetitle = pagetitle
        this.startprint(needreflash)
      },
      cancelprint(){
        this.showtitle1 = "none"
        this.isprint = false
      },
      startprint(needreflash,hideprice) {
        this.showtitle1 = ""
        this.isprint = true
        if(hideprice){
          this.printDisplay=false
        }
        this.$nextTick(() => {
          this.$print(this.$refs.print1)
          this.showtitle1 = "none"
          this.isprint = false
          save({erpserial: this.erpserial, invoicesource: 5}).then(response => {
            if(hideprice){
              this.printDisplay=true
            }

            if (response.data.code == 0) {
              if (needreflash) {
                this.dialogMachiningVisible = false
                this.$emit("bindGrid");//未打印过，刷新父页面
              }
              this.$message({
                message: '生成打印日志',
                type: 'success'
              })
            }
          })
        })
      },
      show(roletype) {
        this.roletype = roletype
        this.dialogMachiningVisible = true;
      },
      contains(item, arr) {
        for (var i = 0; i < arr.length; i++) {
          if (arr[i] == item) {
            return true;
          }
        }
        return false;
      },
      getLiuYan(remark) {
        return getRemark(remark);
      },
      lookDetails(row) {
        this.$parent.lookMachiningCopy(row)
      },
      //是否显示价格
      diaplayprice() {
        let temp = JSON.parse(localStorage.getItem("hpapi_userInfoModel"))
        if (temp.myright.indexOf('财务') != -1 || temp.myright.indexOf('查看订单价格') != -1) {
          this.showlookprice = true;
        } else {
          this.showlookprice = false;
        }
      },
      initData(row, canOperate,isfahuo) {
        this.initForm()
        this.btn=isfahuo;
        this.isfahuo=isfahuo=='填写发货单'
        this.canOperate = canOperate
        this.formpropertyData = []
        this.erpserial = row.erpserial
        this.groupguid = row.groupguid
        this.unitguid = row.unitguid
        this.imgpath = window.API_ROOT + "/api/avatar/getBarcode?content=" + row.erpserial
        this.status = row.status
        if (row.logisticsnum) {
          this.controlData.logisticsnum = row.logisticsnum
        }
        this.bindGrid()
      },
      bindGrid() {
        machiningOrder({
          unitguid: this.unitguid,
          groupguid: this.groupguid,
          erpserial: this.erpserial
        }).then(response => {
          if(this.batchprint){
            this.isprint=true;
          }
          //打印日志
          if (!this.batchprint&&response.data.obj.printlogDOList && response.data.obj.printlogDOList.length > 0) {
            this.printData = response.data.obj.printlogDOList
            this.uname = this.printData[0].uname
            this.adddate = this.printData[0].adddate
          }
          this.controlData = response.data.obj.detail;
          this.$refs.CstagreementMachiningPrint1.initData({},response.data.obj);//小票打印

          if (this.controlData.remark != '' && this.controlData.remark != undefined) {
            var remark = JSON.parse(this.controlData.remark.replace(new RegExp("\n", "gm"), ""));
            remark.forEach(item => {
              if (item.type == '眼镜已到') {
                this.checkedGlasses = item.msg == '' || item.msg == undefined ? [] : item.msg.split(',')
              }
            })
          }
          this.tableData = response.data.obj.goodsDetail;
          this.sumnumber = response.data.obj.sumnumber
          this.summoney = response.data.obj.summoney

          if (!this.controlData.logisticsco) {
            var logItem = '';
            if (this.controlData.deliverymode) {
              for (let i in this.parameterData) {
                if (this.parameterData[i].name == this.controlData.deliverymode) {
                  logItem = this.parameterData[i].name;
                  break;
                }
              }
            }
            if (logItem) {
              this.controlData.logisticsco=logItem;
            } else {
              this.controlData.logisticsco = this.parameterData.length > 1 ? this.parameterData[1].name : (this.parameterData.length > 0 ? this.parameterData[0].name : '')
              if (this.controlData.logisticsco == '顺丰到付') this.controlData.logisticsco = this.parameterData[0].name;
            }
          }

          if (this.btn == '邮寄' && this.controlData.logisticsco == '待邮寄') {
            this.controlData.logisticsco = this.parameterData.length > 0 ? this.parameterData[0].name : '';
          }
          if(this.btn=='填写发货单'&&!this.controlData.logisticsnum){
            for (let i in this.parameterData) {
              if (this.parameterData[i].name == '待邮寄') {
                this.controlData.logisticsnum='';
                this.controlData.logisticsco='待邮寄';
                break;
              }
            }
          }

          if(!this.batchprint)
           this.bindBaoSun();

          if (this.controlData.isreturnorder && this.controlData.isreturnorder == 1) {
            this.isreturnorder = true
          } else {
            this.isreturnorder = false
          }
          if (this.controlData.isreturnorder == -1) {
            this.backimg = 'url("/static/img/tuihuotipbig.png") center center no-repeat';
          }
          this.pagetitle = this.getTitle(response.data.obj.detail.printdname);
          this.seedname = response.data.obj.seedname;
          this.seedcode=response.data.obj.seedcode;
          this.formproperty = response.data.obj.parameter;
          if(this.formproperty&&this.formproperty['处方单']) {
            this.chufangdan = this.formproperty['处方单'];
            if (this.$refs.RLTable1)
              this.$refs.RLTable1.init(this.formproperty['处方单']);
          }
          this.printDisplay = (this.controlData.isshowprice.indexOf('4') != -1);

          this.tableDatamap=[]

          if (this.tableData.length > 0) {
            let showrl = false
            var showzw = false;
            var showadd = false;
            var showtongd = false;
            for (let i in this.tableData) {
              for (let j in this.tableData[i]) {
                if (j == "R/L") {
                  showrl = true;
                } else if (j == "轴位") {
                  showzw = true;
                } else if (j == "ADD") {
                  showadd = true;
                } else if (j == "通道") {
                  showtongd = true;
                }
              }
            }
            this.column = []
            if (showrl)
              this.column.push("R/L")
            this.column.push("产品名称")
            this.column.push("球镜")
            this.column.push("柱镜")
            if (showzw)
              this.column.push("轴位")
            if (showadd)
              this.column.push("ADD")
            if (showtongd)
              this.column.push("通道")
            this.column.push("销售单号")
            this.column.push("数量")
            if (this.printDisplay || this.showlookprice) {//需要打印价格的才加载单价
              this.column.push("单价")
              this.column.push("总价")
            }
            this.toBaosunData();
          }
        });
      },
      toBaosunData() {
        this.columnbaosun = []
        //取出表头
        let temparr = []
        let biaoji = 0
        for (let i in this.tableData) {
          if (this.tableData[i]["订单状态"] != "已发货") {
            this.count++
          }
          for (let j in this.tableData[i]) {
            if (j == "R/L") {
              biaoji = 1
            }
            if (j != "seedcode" && j != "R/L" && j != "数量" && j != "订单状态" && j != "说明" && j != "产品名称" && j != "球镜" && j != "柱镜" && j != "轴位" && !this.contains(j, temparr) && j != "单价" && j != "总价") {
              temparr.push(j)
            }
          }
        }
        //对表头排序
        this.columnbaosun.push("seedcode")
        if (biaoji == 1) {
          this.columnbaosun.push("R/L")
        }
        this.columnbaosun.push("产品名称")
        this.columnbaosun.push("球镜")
        this.columnbaosun.push("柱镜")
        this.columnbaosun.push("轴位")
        this.columnbaosun = this.columnbaosun.concat(temparr)
        this.columnbaosun.push("数量")
        this.columnbaosun.push("订单状态")
        this.columnbaosun.push("单价")
        this.columnbaosun.push("总价")
        //this.column.push("说明")


        this.tableDatamap = this.tableData.map(o1 => this.columnbaosun.map(o2 => {
          let ob = {}
          ob[o2] = o1[o2]
          return ob
        }))
      },
      machiningOver() {
        // 检查关联销售单是否有退单状态
        for (let i = 0; i < this.tableData.length; i++) {
          var statusName = this.tableData[i]['订单状态'];
          if (statusName && (statusName.indexOf('退货') !== -1 || statusName.indexOf('退款') !== -1)) {
            this.$message.error('关联的销售单（' + (this.tableData[i]['销售单号'] || '') + '）已是退单状态，不允许操作加工完成');
            this.loading = false;
            return;
          }
        }
        this.loading=true;
        finishing({unitguid: this.unitguid}).then(response => {
          if (response.data.code == 0) {
            this.$message({
              message: '加工完成',
              type: 'success'
            })
            this.handlelog("加工完成");
          } else {
            this.loading=false
            this.$message({
              message: response.data.msg,
              type: 'error'
            })
          }

          this.dialogMachiningVisible = false
          //刷新列表
          this.$emit("bindGrid")
        })
      },
      showError(errorinfo) {
        this.$message({
          message: errorinfo,
          type: 'error'
        })
        this.loading=false
      },
      delivergoods() {
        if(this.controlData.logisticsco==null)
          this.controlData.logisticsco='';

        if (!(this.controlData.logisticsco.indexOf('配送') > -1 || this.controlData.logisticsco.indexOf('自取') >-1|| this.controlData.logisticsco.indexOf('邮寄') > -1)&&!this.controlData.logisticsnum ) {
          this.showError('请填写快递单号！')
          return;
        }
        this.loading=true
        multipleShipments({
          erpserial: this.controlData.erpserial,
          deliverymode: this.controlData.deliverymode,
          logisticsco: this.controlData.logisticsco,
          logisticsnum: this.controlData.logisticsnum,
          customername: this.controlData.customername,
          jxcformdetaillist: this.controlData.jxcformdetaillist,
          customerserial: this.controlData.customerserial,
          independentserial: '',
          cangkucode: this.controlData.cangkucode,
          cangkuname: this.controlData.cangkuname,
          origionstatus: '',
          jxcformDetailDo: '',
          isdistribute: '',
          formtype: 72,
          orderopinion: '',
          eliverydStatus: '',
          storegoodsbarcode: '',//库存商品唯一条码
          logisticstracknum: '',//跟踪单号
          invoicesource: 2
        }).then(response => {
            if (response.data.code == 0) {
              this.$message({
                message: response.data.msg,
                type: 'success'
              })
              this.dialogMachiningVisible = false
              this.handlelog("仓库发货");
              //刷新列表
              this.$emit("cutItemAfterHandle", this.controlData.erpserial)
            } else {
              this.showError(response.data.msg)
            }
          }
        );
      },
      erchidelivergoods() {
        if (this.controlData.logisticsco != '配送' && this.controlData.logisticsco != '自取') {
          if (!this.controlData.logisticsnum) {
            this.$message({message: '请输入物流单号', type: 'error', duration: 1500})
            return
          }
        }
        this.loading=true
        ercifahuo({unitguid:this.controlData.unitguid,logisticsnum:this.controlData.logisticsnum.trim(),logisticsco:this.controlData.logisticsco}).then(response => {
          if (response.data.code == 0) {
            this.$message({
              message: '保存成功！',
              type: 'success'
            })
            this.$emit('bindGrid');
            this.dialogMachiningVisible = false;
          } else {
            this.$message({
              message: response.data.msg,
              type: 'error'
            })
          }
          this.loading=false
        })
      },
      initForm() {
        if (this.$refs.form1 != undefined) {
          this.$refs.form1.resetFields();
        }
        this.chufangdan='';
        if (this.$refs.RLTable1)
          this.$refs.RLTable1.reset();
        this.diaplayprice();
        this.loading=false;
        this.backimg = '';
        this.groupguid = ""
        this.column = []
        this.tableData = []
        if (this.$refs.BaoSunList)
          this.$refs.BaoSunList.clear();
        this.unitguid = ""
        this.uname = ''
        this.adddate = ''
        this.printDisplay = false
        this.checkedGlasses = [];
        this.printData=[];
      },
      createOrderService() {
        this.loading=true
        sfOrderService({
          unitguid: this.unitguid,
          cangkucode: this.controlData.cangkucode,
          paymethod: this.controlData.logisticsco
        }).then(response => {
          if (response.data.code == 0) {
            this.controlData.logisticsnum = response.data.msg;
            if (response.data.express) {
              this.$message({
                message: '已创建过快递单！',
                type: 'error'
              })
              this.controlData.logisticsco = response.data.express
            }

            if (response.data.printurl)
              this.OrderPrintFile(response.data.printurl);
            else{
              this.loading=false
            }
          } else {
            this.$message({
              message: response.data.msg,
              type: 'error'
            })
            this.loading=false
          }
        });
      },
      RouteService() {
        this.supplystatuslist=[];
        sfRouteService({erpserial: this.controlData.erpserial, expressno: this.controlData.logisticsnum}).then(response => {
          var newarrr = []
          for (let i in this.supplystatuslist) {
            if (!this.supplystatuslist[i].express) {
              newarrr.push(this.supplystatuslist[i])
            }
          }
          for (let i in response.data.obj) {
            var row = response.data.obj[i]
            newarrr.push({FlagCode: row.status, FlagDateTime: row.time, express: true})
          }
          this.supplystatuslist = newarrr;
          this.supplydrawer = true;
        });
      },
      OrderPrint() {
        this.loading=true
        sfOrderPrint({erpserial: this.controlData.erpserial,expressno:this.controlData.logisticsnum}).then(response => {
          if(response.data.code==1){
            this.$message({message: response.data.msg,type: 'error'});
            this.loading=false
            return;
          }
          this.OrderPrintFile(response.data.printurl);
        });
      },
      OrderPrintFile(printurl) {
        var thisFun=this;
        loadPrintFile(printurl,this.controlData.cangkucode,function () {
          thisFun.$message({
            message: '已发送到打印机！',
            type: 'success'
          })
          thisFun.loading = false;
        });
      },
      removeOrderService() {
        this.loading=true
        this.$confirm("是否确定撤销快递单？", '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          sfOrderConfirm({erpserial: this.controlData.erpserial,expressno:this.controlData.logisticsnum}).then(response => {
            if (response.data.code == 0) {
              this.controlData.logisticsnum = '';
              this.$message({
                message: '已成功取消',
                type: 'success'
              })
            } else {
              this.$message({
                message: response.data.msg,
                type: 'error'
              })
            }
            this.loading=false
          })
        }).catch(() => {
          this.loading=false
          this.$message({
            type: 'info',
            duration: 1500,
            message: '已取消'
          });
        });

      },
    },
    mounted() {
      this.zjyright = this.$checkRight("质检员")
      getParameterDetail({paraname: "快递公司"}).then(response => {
        for (let i = 0; i < JSON.parse(response.data.obj.paracontent).length; i++) {
          var obj = {
            name: '', value: ''
          }
          obj.name = JSON.parse(response.data.obj.paracontent)[i].name
          obj.value = JSON.parse(response.data.obj.paracontent)[i].name
          this.parameterData.push(obj)
        }
      })
    },
    components: {
      printlogList,
      HandlelogList,
      CstagreementMachiningBaosun,
      CstagreementMachiningPrint,
      BaoSunList,
      Printtitle,
      RLTable,
      UpdateExpressFee
    }

  }
</script>

<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 22px;
    line-height: 16px;
    padding: 2px;
    font-size: 12px;
  }

  .query-table td.content {
    text-align: center;
  }

  .noborder td {
    border: none;
    font-size: 12px;
  }


</style>





// WEBPACK FOOTER //
// src/components/testorder/cstagreement/CstagreementMachiningEdit.vue